import jwt from "jsonwebtoken";
import { Request, Response } from "express";

const getToken = (req: Request, res: Response) => {
	const token = req.headers.token;

	const returnUser = {
		userID: null,
		level: 0,
	};

	if (token == null) {
		// console.log('token is null')
		req.user = returnUser;

		res.status(401);
	} else {
		jwt.verify(token, "secret-key", (err, user) => {
			if (err) {
				// console.log('token is error')
				req.user = returnUser;

				res.status(403);
			}

			// console.log('valid user')
			req.user = user;
		});
	}
};

export default getToken;
